export const getShipmentEndpoint = (shipmentUid: string) => `/shipments/${shipmentUid}`
